export default __webpack_public_path__ + "19af040f0145c13cd8e6ff7ad149566b.svg";